module.exports = __webpack_public_path__ + "simquadrat_bw.svg?ddd62868bd1ba101839096f4e321f7bc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patterns/simquadrat_bw.svg
// module id = 5
// module chunks = 0